import React, { Fragment, useState, useLayoutEffect, useContext } from "react";
import { Col } from "reactstrap";
import { AlignCenter } from "react-feather";
import { Link } from "react-router-dom";
import { H5, Image } from "../../../AbstractElements";
import CustomizerContext from "../../../_helper/Customizer";
import { useTranslation } from "react-i18next";
// import { useClinicAdmin } from "../../../_helper/ClinicProvider";
import { MarginBottom } from "../../../Constant";
import { usePharmacy } from "../../../_helper/PharmacyProvider";
import S3ImageLoader from "../../../S3ImageLoader";
import man from "../../../assets/images/hospital.png";
import fallBackImg from "../../../assets/images/logo/logo.png"

const Leftbar = () => {
  const { setToggleIcon, toggleSidebar } = useContext(CustomizerContext);
  const [sidebartoggle, setSidebartoggle] = useState(true);
  const width = useWindowSize();
  const { t } = useTranslation()
  // const auth0_hospital_admin_profile = JSON.parse(localStorage.getItem("currentHospitalAdmin"));
  const [name, setName] = useState("Hospital Admin");
  // const { clinicAdmin } = useClinicAdmin();
  const { pharmacyPOS } = usePharmacy();
  const pharmacyLogo = process.env.REACT_APP_IMAGE + pharmacyPOS.logo

  function useWindowSize() {
    const [size, setSize] = useState([0, 0]);
    useLayoutEffect(() => {
      function updateSize() {
        setSize([window.innerWidth, window.innerHeight]);
        if (window.innerWidth <= 991) {
          setToggleIcon(true);
        } else {
          setToggleIcon(false);
        }
      }
      window.addEventListener("resize", updateSize);
      updateSize();
      return () => window.removeEventListener("resize", updateSize);
    }, []);
    return size;
  }

  const responsive_openCloseSidebar = (toggle) => {
    if (width <= 991) {
      toggleSidebar(!toggle);
      document.querySelector(".sidebar-wrapper").className = "sidebar-wrapper ";
      document.querySelector(".bg-overlay1").classList.add("active");
    } else {
      if (toggle) {
        toggleSidebar(!toggle);
        document.querySelector(".sidebar-wrapper").className = "sidebar-wrapper close_icon ";
      } else {
        console.log("991 54 else", toggle);
        toggleSidebar(!toggle);
        document.querySelector(".sidebar-wrapper").className = "sidebar-wrapper ";
      }
    }
  };

  return (
    <Fragment>
      <Col className="header-logo-wrapper col-auto p-0" id="out_side_click">
        <div className="logo-wrapper">
          <Link to={`${process.env.PUBLIC_URL}/dashboard`}>
            <div className="pharmacy-logo">
              <img
                src={'../../../assets/images/logo/logo.png'}
                alt="Pharmacy Logo"
                onError={(e) => (e.target.src = fallBackImg)}
              />
              {/* <S3ImageLoader
                className="m-0"
                fileName={'../../../assets/images/logo/logo.png'}
                style={{ height: '100%', width: '100%', objectFit: 'cover' }}
                alt="profile"
                fallbackSrc={man}
              /> */}
              {/* <h6 className="mb-0 ms-2 fw-bold">{pharmacyPOS?.facility_name || ''}</h6> */}
            </div>

            {/* <Image
              attrImage={{
                className: "img-fluid for-light",
                src: `${pharmacyLogo || require("../../../assets/images/logo/logo.png")}`,
                alt: "",
              }}
            />
            <Image
              attrImage={{
                className: "img-fluid for-dark",
                src: `${pharmacyLogo || require("../../../assets/images/logo/logo.png")}`,
                // src: `${require("../../../assets/images/logo/logo_dark.png")}`,
                alt: "",
              }}
            /> */}
          </Link>
        </div>
        {/* <h6 className="mb-0 ms-2 fw-bold">{pharmacyPOS?.facility_name}</h6> */}
        {/* <div className="toggle-sidebar" onClick={() => responsive_openCloseSidebar(sidebartoggle)} style={window.innerWidth <= 991 ? { display: "block" } : { display: "none" }}>
          <AlignCenter className="status_toggle middle sidebar-toggle" id="sidebar-toggle" />
        </div> */}
      </Col>
      {pharmacyPOS.hospital && (
        <Col xxl="5" xl="6" lg="5" className="left-header p-0 d-flex align-items-center justify-content-center col-sm-auto">
          {pharmacyPOS.hospital.logo !== "" && pharmacyPOS.hospital.logo ? (
            <S3ImageLoader
              className="m-0 b-r-10"
              fileName={pharmacyPOS?.hospital.logo}
              style={{ height: '32px', width: '32px', objectFit: 'cover' }}
              alt="profile"
              fallbackSrc={man}
            />
          ) : null}
          <h6 className="mb-0 ms-2 fw-bold">{pharmacyPOS?.hospital?.name}</h6>
        </Col>
      )}
    </Fragment>
  );
};

export default Leftbar;
